import { getEnvVar, isElectron } from 'utils/environment';

export async function readWorkstationName(): Promise<string | null> {
  const override = getEnvVar('VITE_WORKSTATION_NAME');
  if (override) return override;
  if (!isElectron || !window.api?.readWorkstationName) return null;
  return (await window.api.readWorkstationName()) || null;
}
